import { render, staticRenderFns } from "./appointmentTips.vue?vue&type=template&id=2e68a46a&scoped=true&"
import script from "./appointmentTips.vue?vue&type=script&lang=js&"
export * from "./appointmentTips.vue?vue&type=script&lang=js&"
import style0 from "./appointmentTips.vue?vue&type=style&index=0&id=2e68a46a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e68a46a",
  null
  
)

export default component.exports